function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function moveMagnifier(image, event, lens, result, zoomRatio) {
  const imageRect = image.getBoundingClientRect();
  const infoRect = image.closest('.product')?.querySelector('.product__info-wrapper')?.getBoundingClientRect();
  if (!infoRect?.width) return;

  const resultSize = Math.min(infoRect.width, imageRect.height, window.innerHeight - 32);
  const lensSize = resultSize / zoomRatio;
  const x = clamp(event.clientX - imageRect.left, lensSize / 2, imageRect.width - lensSize / 2);
  const y = clamp(event.clientY - imageRect.top, lensSize / 2, imageRect.height - lensSize / 2);

  Object.assign(lens.style, {
    display: 'block',
    width: `${lensSize}px`,
    height: `${lensSize}px`,
    left: `${x - lensSize / 2}px`,
    top: `${y - lensSize / 2}px`,
  });

  Object.assign(result.style, {
    display: 'block',
    width: `${resultSize}px`,
    height: `${resultSize}px`,
    left: `${infoRect.left}px`,
    top: `${clamp(imageRect.top, 16, window.innerHeight - resultSize - 16)}px`,
    backgroundImage: `url('${image.currentSrc || image.src}')`,
    backgroundSize: `${imageRect.width * zoomRatio}px ${imageRect.height * zoomRatio}px`,
    backgroundPosition: `${resultSize / 2 - x * zoomRatio}px ${resultSize / 2 - y * zoomRatio}px`,
  });
}

function enableZoomOnHover(zoomRatio) {
  const desktopPointer = window.matchMedia('(min-width: 990px) and (hover: hover)');

  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    const host = image.closest('.product__modal-opener--image');
    if (!host || host.dataset.magnifierReady) return;
    host.dataset.magnifierReady = 'true';

    host.addEventListener('mouseenter', (event) => {
      if (!desktopPointer.matches) return;

      document.querySelectorAll('.image-magnify-lens, .image-magnify-result').forEach((element) => element.remove());

      const lens = document.createElement('div');
      const result = document.createElement('div');
      lens.className = 'image-magnify-lens';
      result.className = 'image-magnify-result';
      lens.setAttribute('aria-hidden', 'true');
      result.setAttribute('aria-hidden', 'true');
      host.appendChild(lens);
      document.body.appendChild(result);

      const move = (moveEvent) => moveMagnifier(image, moveEvent, lens, result, zoomRatio);
      const remove = () => {
        host.removeEventListener('mousemove', move);
        lens.remove();
        result.remove();
      };

      host.addEventListener('mousemove', move);
      host.addEventListener('mouseleave', remove, { once: true });
      move(event);
    });
  });
}

enableZoomOnHover(2.5);
